import { axiosApi } from "shared/api/axios";
import { ResponseMetrics } from "../types";

export const getMetrics = async (
    query?: string
): Promise<ResponseMetrics[]> => {
    try {
        const baseUrl = `${process.env.API_BACKEND}/v1/dashboard/dashboard/metrics/${query}`
        const response = await axiosApi.get<ResponseMetrics[]>(baseUrl);
        return response.data;
    } catch (err) {
        console.error("Error fetching clients", err);
        return [];
    }
};